import styled, { css } from 'styled-components';
import { mobile } from '@web-chat-core/ui-kit';

interface ContainerProps {
    withoutBackground: boolean;
    heightOverflow?: boolean;
}

const overflowHidden = css<ContainerProps>`
    overflow: hidden;
    align-self: stretch;
`;

export const Container = styled.div<ContainerProps>`
    width: 100%;
    background-color: ${props => (props.withoutBackground ? 'transparent' : props.theme.root.colors.basicColors['4%'])};
    ${props => props.heightOverflow === true && overflowHidden}
`;

interface MemberProps {
    isSmall?: boolean;
}

export const Member = styled.div<MemberProps>`
    position: relative;
    display: flex;
    height: ${props => (props.isSmall ? '46px' : '64px')};
    padding: ${props => (props.isSmall ? '0px 16px' : '8px 16px')};
    box-sizing: border-box;
    align-items: center;
    width: 100%;

    font-size: 14px;

    ${mobile`
        max-width: 100%;
    `}
`;

export const Avatar = styled.div<{ isSmall?: boolean }>`
    position: relative;
    width: ${props => (props.isSmall ? '30px' : '48px')};
    height: ${props => (props.isSmall ? '30px' : '48px')};

    border-radius: 50%;
    background-color: ${props => props.theme.root.colors.basicColors['10%']};
`;

export const Message = styled.div`
    display: flex;
    margin-left: 12px;
    flex-wrap: wrap;
    flex-direction: column;
    flex-grow: 1;
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24px;
`;

type WidthType = 'small' | 'withBadge' | 'full';

const detectWidth = (widthType?: WidthType): string => {
    if (widthType === 'small') {
        return '43%';
    }
    if (widthType === 'withBadge') {
        return '80%';
    }

    return '100%';
};

export const Line = styled.div<{ widthType?: WidthType }>`
    height: 16px;
    width: 100%;
    padding-right: 15px;
    max-width: ${props => detectWidth(props.widthType)};

    border-radius: 10px;
    background-color: ${props => props.theme.root.colors.basicColors['10%']};
`;
